import { useMutation, useQueryClient } from '@tanstack/react-query';
import request from '@teetsh/app/src/utils/request';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import livretKeys from './keys';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';
import { LivretEleveDiff } from '../LivretEval/LivretEleve/components/LivretEleve/SyncLivret/types';

interface PatchLivretEleveDTO {
  livretEleveId: string;
  diff: LivretEleveDiff[];
}

function updateLivretEleve({
  schoolyearId,
  schoolId,
  livretEleveId,
  diff,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEleveId: string;
  diff: LivretEleveDiff[];
}): Promise<void> {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livret-eleves/${livretEleveId}/diff`;
  return request(requestURL, {
    method: 'PATCH',
    body: {
      diff,
    },
  });
}

export function useUpdateLivretEleveDiff({
  livretEvalId,
}: {
  livretEvalId: string;
}) {
  const { notifyError, notifySuccess } = useNotification();
  const { schoolyear, school } = useSchoolSchoolyear();
  const queryClient = useQueryClient();
  const { t } = useTranslation(['carnet']);
  const { mutateAsync, isPending: isLoading } = useMutation<
    void,
    AxiosError,
    PatchLivretEleveDTO
  >({
    mutationFn: (payload: PatchLivretEleveDTO) =>
      updateLivretEleve({
        schoolId: school.id,
        schoolyearId: schoolyear.id,
        ...payload,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: livretKeys.livretDetail(
          schoolyear.id,
          school.id,
          livretEvalId,
        ),
      });
      notifySuccess({
        title: t('carnet:syncLivret.messages.updateLivretEleveDiffSuccess'),
      });
    },
    onError: () => {
      notifyError({
        title: t('carnet:syncLivret.messages.updateLivretEleveDiffError'),
      });
    },
  });
  return { mutateAsync, isLoading };
}
